import { Box, Button, Paper, Typography } from "@mui/material";
import React from "react";
import AsyncSearchBar from "../../components/inputs/AsyncSearchBar";
import DataTable from "../../components/tables/DataTable";
import { USER_ROLES } from "../../utils/constants";
import { useSelector } from "react-redux";

const PurchaseRequestListUi = ({
  onCreateBtnClick,
  onDirectPurchaseBtnClick,
  list,
  setList,
  loading,
  filters,
  columns,
  setFilters,
}) => {
  const user = useSelector((state) => state.user);
  return (
    <Paper elevation={2} sx={{ width: "100%", padding: 6 }}>
      <Box
        display={"flex"}
        flexDirection={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Box>
          <Typography variant="h3" color={"primary"}>
            Material Requests
          </Typography>
        </Box>

        <Box gap={2} display={"flex"}>
          <Button
            variant="contained"
            onClick={onCreateBtnClick}
            sx={{
              width: "100%",
              height: "6vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="h5">Create Material Request</Typography>
          </Button>

          {user?.data.role == USER_ROLES.PRODUCTION &&
            user?.data.isDepartmentHead && (
              <Button
                variant="outlined"
                onClick={onDirectPurchaseBtnClick}
                sx={{
                  width: "100%",
                  height: "6vh",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography variant="h5">Direct Purchase</Typography>
              </Button>
            )}
        </Box>
      </Box>

      <Box mt={4} width={"100%"} display={"flex"} justifyContent={"flex-end"}>
        <Box
          mb={4}
          sx={{ display: "flex", width: "20vw", justifyContent: "flex-end" }}
          pl={3}
        >
          <AsyncSearchBar
            fullWidth
            title="Search By Request ID"
            size="small"
            placeholder={"Search By Request ID"}
            defaultValue={filters.search}
            onChange={(changedVal) => {
              setFilters({
                ...filters,
                pageNo: 1,
                pageSize: 10,
                search: changedVal,
              });
            }}
          />
        </Box>
      </Box>

      <Box sx={{ minHeight: "40vh" }}>
        <DataTable
          columns={columns}
          rows={list?.result ? list?.result : []}
          count={list?.total ?? 0}
          filters={filters}
          setFilters={setFilters}
          loading={loading}
        />
      </Box>
    </Paper>
  );
};

export default PurchaseRequestListUi;
